import { MAX_RESPAWN_POINT_NAME_CHARS } from "./respawn.ts";

/**
 * Waypoint travel's bounds and words (ADR-137 decisions 11 to 13, PROTOCOL.md 6.83.0): five text messages, `travelAsk`,
 * `travelOffer`, `travel`, `travelCancel` and `travelState`. Their field tables are in `text.ts`, which `encodeText`
 * and `parseTextFrame` apply.
 */

/**
 * The most places a `travelOffer` carries, and so one more than the largest `index` a `travel` names: a map holds at
 * most 64 shrines and waypoints between them (ADR-137 decision 4). Travel across maps (ADR-137 decision 27) raises it
 * with the protocol minor that sends those places.
 */
export const MAX_TRAVEL_PLACES = 64;

/**
 * The longest name, region or map name a travel message carries, in UTF-16 units: a respawn point's.
 */
export const MAX_TRAVEL_NAME_CHARS = MAX_RESPAWN_POINT_NAME_CHARS;

/**
 * The most Focus a place can cost, in points: a pool holds 100 at every level (ADR-137 "Still current").
 */
export const MAX_TRAVEL_FOCUS = 100;

/**
 * Where a travel offer starts: from a shrine's or a waypoint's activation cells, or from anywhere (ADR-137 decision 7).
 */
export const TRAVEL_OFFER_SOURCES = ["shrine", "anywhere"] as const;

/**
 * The kind of a place in an offer (ADR-137 decision 8): a shrine or a waypoint.
 */
export const TRAVEL_PLACE_KINDS = ["shrine", "waypoint"] as const;

/**
 * The states of a `travelState` (ADR-137 decision 12): the channel starts, completes, is broken, or the request is
 * refused.
 */
export const TRAVEL_STATES = ["channel", "done", "broken", "refused"] as const;

/**
 * The ways a travel request or channel ends that are not refusals of the rule (`TRAVEL_REFUSALS`): the character moved
 * or was damaged (ADR-137 decision 15), left the map server, a world version swapped, the choice named an offer or
 * place that is no longer so (`stale`), or the player cancelled. `cancelled`, the answer to `travelCancel`, is this
 * wire's addition to decision 15's list.
 */
export const TRAVEL_BREAK_REASONS = ["moved", "damaged", "left", "version", "stale", "cancelled"] as const;

/**
 * A `travelState` reason as the wire carries it: 1 to 16 lower-case letters, so a code a later server names is a value
 * a page words generically and not a malformed frame (ADR-137 decision 31).
 */
export const TRAVEL_REASON_PATTERN = /^[a-z]+$/;

/**
 * The longest `travelState` reason on the wire.
 */
export const MAX_TRAVEL_REASON_CHARS = 16;

/**
 * A place's reason in a `travelOffer` as the wire carries it: empty when the character can pay, otherwise 1 to 16
 * lower-case letters (`short`, `focus`, `outlaw` today), so a reason a later server names is a value a page words
 * generically and not a malformed frame.
 */
export const TRAVEL_PLACE_REASON_PATTERN = /^[a-z]*$/;
